module.exports = __webpack_public_path__ + "static/media/my-sessions.08dce4e1.svg";